import {MarkDownContent} from "../../../common/types/post.types";
import {getFileContent} from "../../../utils/api";
import { useEffect, useState } from "react";
import 'katex/dist/katex.css';
import ReactMarkdown from "react-markdown";
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from "rehype-katex";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import remarkImages from "remark-images";
import rehypeRaw from "rehype-raw";

function Markdown(props: Props) {
  const [data, setData] = useState('');

  useEffect(() => {
    if (props.data.content) {
      setData(props.data.content);
    } else if (props.data.file) {
      getFileContent(props.data.file).then((res) => {
        setData(res);
      });
    }
  }, [props.data])

  return (
    <ReactMarkdown
      children={data}
      remarkPlugins={[remarkGfm, remarkMath, remarkImages]}
      rehypePlugins={[rehypeKatex, rehypeRaw]}
      components={{
        code({node, inline, className, children, ...props}) {
          const match = /language-(\w+)/.exec(className || '')
          return !inline && match ? (
            <SyntaxHighlighter
              children={String(children).replace(/\n$/, '')}
              style={dracula}
              language={match[1]}
              PreTag="div"
              {...props}
            />
          ) : (
            <code className={className} {...props}>
              {children}
            </code>
          )
        }
      }}
    />
  )
}

export default Markdown;

class Props {
  data: MarkDownContent
}
